import { SectionContainer, SectionRoot } from '@exploration/shared-components';
import { desktop } from '@thrivent/midwest-shared';
import { MDSText } from '@thrivent/midwest-web';
import styled from 'styled-components';

export const OfferingsSectionStyles = {
  Section: styled(SectionRoot)`
    background-color: ${(p) => p.theme.midwestColors.backgroundPrimary};
  `,
  Container: styled(SectionContainer)`
    padding-block: 2.5rem;
    gap: 1rem;
    ${desktop} {
      min-height: fit-content;
      padding-block: 5rem;
      gap: 1.5rem;
    }
  `,
  TitleContainer: styled.div`
    flex: 1;
    color: ${(p) => p.theme.midwestColors.textTertiary};
  `,
  Title: styled(MDSText.TitleMd)`
    ${desktop} {
      display: none;
    }
  `,
  TitleDesktop: styled(MDSText.TitleSm)`
    display: none;
    ${desktop} {
      display: block;
    }
  `,
  ContentContainer: styled.div`
    flex: 1;
  `,
  Heading: styled(MDSText.BodyHeavyDefault)``,
  Description: styled(MDSText.BodyRegDefault)``,
};
